export default __webpack_public_path__ + "static/media/IMG-20240708-WA0012.3dbe45a7.jpg";